import {
  TableCellProps,
} from 'spindl-shared-components';


type CSVRowInternalProps = {
  checkbox?: TableCellProps;
  name?: TableCellProps;
  email?: TableCellProps;
  role?: TableCellProps;
};

type CSVRowPropsValues = {
  'Default': CSVRowInternalProps;
  'Header': CSVRowInternalProps;
  'divDefault': CSVRowInternalProps;
  'divHeader': CSVRowInternalProps;
};

const propValues: CSVRowPropsValues = {
  'Default': {
    checkbox: {
      type: 'Checkbox',
      state: 'Default',
      size: 'XS',
    },
    name: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
    email: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
    role: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
  },
  'Header': {
    checkbox: {
      type: 'Checkbox',
      state: 'Default',
      size: 'XS',
    },
    name: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
    email: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
    role: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
  },
  'divDefault': {
    checkbox: {
      type: 'Checkbox',
      state: 'Default',
      size: 'XS',
    },
    name: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
    email: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
    role: {
      type: 'Text',
      state: 'Default',
      size: 'FullWidth',
    },
  },
  'divHeader': {
    checkbox: {
      type: 'Checkbox',
      state: 'Default',
      size: 'XS',
    },
    name: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
    email: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
    role: {
      type: 'Heading',
      state: 'Default',
      size: 'FullWidth',
    },
  },
};

const getProps = (type: string): CSVRowInternalProps => {
  const values: CSVRowInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
